import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import styled, { css } from 'styled-components';

import BgImageFive from '../assets/cta-variant-five.png';
import BgImageFour from '../assets/cta-variant-four.png';
import BgImageOne from '../assets/cta-variant-one.png';
import BgImageThree from '../assets/cta-variant-three.png';
import BgImageTwo from '../assets/cta-variant-two.png';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { Label } from '@/src/views/GlobalBenefitsReport/slices/BenefitsOverviewSlice';
import {
  Title,
  DescriptionWrapper,
  CTAButton as CTAButtonWrapper,
  Section as SectionComponent,
} from '@/src/views/GlobalBenefitsReport/slices/CtaSlice';
import { SimpleFormModalButton } from '@/src/views/Referrals/SimpleForm';

export const Section = styled(SectionComponent)`
  && {
    && {
      ${ContentContainer} {
        flex-direction: column;
        text-align: center;
        align-items: center;
      }

      ${Title}, ${DescriptionWrapper} {
        max-width: 90%;
        margin: 0 auto;
      }

      ${({ $variant }) => {
        switch ($variant) {
          case 'second':
            return css`
              background-image: url(${BgImageTwo.src});
              background-color: #e6627b;
              background-size: cover;
            `;
          case 'third':
            return css`
              background-color: #d3433c;
              background-image: url(${BgImageThree.src});
              background-size: cover;
            `;
          case 'fourth':
            return css`
              background-color: #e03d5c;
              background-image: url(${BgImageFour.src});
            `;

          case 'fifth':
            return css`
              background-image: url(${BgImageFive.src});
              background-color: #a1302b;

              ${Title}, ${DescriptionWrapper} {
                max-width: 686px;
              }
            `;

          default:
            return css`
              background-color: #e03d5c;
              background-image: url(${BgImageOne.src});
            `;
        }
      }}
    }
  }
`;

export const CTAButton = styled(CTAButtonWrapper)`
  && {
    && {
      color: #d3433c;
      text-transform: none;
      font-size: 16px;
    }
  }
`;

export function CtaSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { label, title, description, ctaLink, ctaLabel, variant } = primary;

  const {
    formId,
    gatedFile,
    modalFormTitle,
    modalFormDescription,
    modalFormSubmitLabel,
    downloadButtonLabel,
    eventName,
  } = context;
  return (
    <Section $variant={variant}>
      <ContentContainer>
        <div>
          {fieldHasContent(label) && <Label>{label}</Label>}
          {fieldHasContent(title) && (
            <Title>
              <PrismicRichText field={title} />
            </Title>
          )}
          {fieldHasContent(description) && (
            <DescriptionWrapper>
              <PrismicRichText field={description} />
            </DescriptionWrapper>
          )}
        </div>
        {ctaLabel &&
          (ctaLink ? (
            <CTAButton href={ctaLink?.url} target={ctaLink?.target}>
              {ctaLabel}
            </CTAButton>
          ) : (
            <SimpleFormModalButton
              modalFormId={formId}
              modalFormSubmitLabel={modalFormSubmitLabel}
              modalFormDescription={modalFormDescription}
              modalFormTitle={modalFormTitle}
              gatedFile={gatedFile}
              gatedFileDownloadLabel={downloadButtonLabel}
              eventName={eventName}
              button={{ as: CTAButton }}
            >
              {ctaLabel}
            </SimpleFormModalButton>
          ))}
      </ContentContainer>
    </Section>
  );
}
